// extracted by mini-css-extract-plugin
export var boxItems = "_cg-1";
export var boxItemsLg = "_cg-2";
export var button = "_cg-7";
export var buttonHoverless = "_cg-9";
export var buttonLg = "_cg-8";
export var filterGroupBox = "_cg-0";
export var icon = "_cg-3";
export var iconSecondary = "_cg-6";
export var iconWrapper = "_cg-4";
export var iconWrapperLg = "_cg-5";
export var truncatedLabel = "_cg-a";